export default "/cyrillic.0b00fbd6-c393d8.woff2";